import { View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { routeHome } from "../../Routes";
import { useEffect, useMemo, useState } from "react";
import { light_black } from "../../StyleHelpers";
import { globalAny, isRHD, logout, recordAnalytics } from "../../utils/Utils";
import SideNav from "../SideNavBar";
import TopAppBar from "../TopAppBar";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import searchIcon from "../../assets/TopNavBarIcon/icon_nav_search.png";
import CustomizeDialogBox from "../DialogMessageBox/CustomizeDialogBox";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import MqttSenderService from "../../services/mqtt/MqttSenderService";
import useMqttStore from "../../store/useMqtt.store";
import { EventType } from "../../enums/EventType";
import { AsyncStorageKeys } from "../../Types";

interface Props {
	children?: any;
	screenTitle?: string;
	navTitle?: string;
	searchIcon?: boolean;
	titleLogo?: any;
	showLogout?: boolean;
	isSettings?: boolean;
	onPressRightIcon?: () => void;
	isNarrow?: boolean;
}

const MainLayoutWithSideNav = (props: Props) => {
	const navigation = useNavigation();
	const mqttSender: MqttSenderService = useMqttStore((state: any) => state.mqttSender);
	const [modalLogout, setModalLogout] = useState(false);
	const mainLayoutStyles = { backgroundColor: light_black, height: "100%" };
	const wheelPositionRightStyles = { width: "100vw", zIndex: -1, height: "100%", marginLeft: props.isNarrow ? "-80px" : "-115px" };
	const wheelPositionLeftStyles = { width: "100vw", zIndex: -1, height: "100%" };

	const closeSetting = () => {
		//@ts-ignore
		navigation.navigate(routeHome, {});
	};

	const dismissModal = () => {
		setModalLogout(false);
	};

	const exitAccount = async () => {
		if (mqttSender) mqttSender?.removeScreen();

		recordAnalytics(EventType.Logout, { email: localStorage.getItem(AsyncStorageKeys.email) });
		logout();
		setModalLogout(false);
	};

	const renderTopBar = useMemo(
		() => (
			<TopAppBar
				leftIcon={closeIcon}
				addTitleMarginLeft={true}
				screenTitle={props.screenTitle}
				onPressLeftIcon={closeSetting}
				rightIcon={props.searchIcon ? searchIcon : ""}
				onPressRightIcon={props.onPressRightIcon}
				titleLogo={props.titleLogo}
				isNav={true}
				isSettings={props.isSettings}
				isNarrow={props.isNarrow}
			/>
		),
		[props.screenTitle, props.searchIcon, props.titleLogo, props.isSettings, props.isNarrow],
	);

	const renderNav = useMemo(() => <SideNav isNarrow={props.isNarrow} currentSelected={props.navTitle} />, [props.navTitle, props.isNarrow]);

	const wheelPositionStyle = () => {
		if (isRHD()) {
			return wheelPositionRightStyles;
		}
		return wheelPositionLeftStyles;
	};

	const renderChildren = useMemo(() => <View style={wheelPositionStyle()}>{props.children}</View>, [props.children, props.isNarrow]);

	const renderMainLayout = () => {
		return (
			<View style={mainLayoutStyles}>
				{renderTopBar}
				{renderNav}
				{renderChildren}
			</View>
		);
	};

	useEffect(() => {
		if (props.showLogout) {
			setModalLogout(true);
		}
	}, [props.showLogout]);

	return (
		<>
			{renderMainLayout()}
			{modalLogout ? (
				<CustomizeDialogBox
					Header={globalAny.language.sure_to_logout}
					Body={globalAny.language.logout_reminder}
					ButtonTextLeft={globalAny.language.logout}
					ButtonTextRight={globalAny.language.cancel}
					SingleButton={false}
					CloseButton={false}
					Width={680}
					Height={"auto"}
					TypeButtonColorLeft={ComponentTypeEnum.Primary}
					TypeButtonColorRight={ComponentTypeEnum.Secondary}
					onDismiss={dismissModal}
					onPressLeft={exitAccount}
					onPressRight={dismissModal}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default MainLayoutWithSideNav;
